import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateWithdrawalExclusionCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type WithdrawalExclusionState = void;

export const WITHDRAWAL_EXCLUSION = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<WithdrawalExclusionState>
  >,
): ConditionType<WithdrawalExclusionState, Condition.WithdrawalExclusion> => ({
  name: CONDITION_NAMES[Condition.WITHDRAWAL_EXCLUSION],
  description() {
    return t(
      "Item is excluded from withdrawal by the team's withdrawal exclusion settings.",
    );
  },
  Details(props: ConditionTypeDetailsProps<WithdrawalExclusionState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.WITHDRAWAL_EXCLUSION };
  },
  valid() {
    return validateWithdrawalExclusionCondition({}).valid;
  },
});
